<p-menubar class="app-header" data-testid="pageHeaderContainer" #headerMenubar>
	<ng-template #start>
		@if (appMain.isMobile()) {
			<a href="#" class="app-header-menu-toggle" (click)="appMain.onMenuButtonClick($event)">
				<i class="pi pi-bars"></i>
			</a>
		}
		<!-- Page Title with Breadcrumbs -->
		@if (appContext.ViewTitle) {
			<div class="app-header-title-container" data-testid="headerTitleBreadcrumbHolder">
				<span class="app-header-title">{{ appContext.ViewTitle }}</span>
				@if (appContext.showBreadcrumb) {
					<ul class="app-header-breadcrumb">
						@for (item of appContext.breadcrumbItems; track (item.url ?? item.label ?? 'breadcrumb') + '-' + $index; let last = $last) {
							<li class="app-header-breadcrumb-item">
								@if (item.url) {
									<a
										[routerLink]="item.url"
										[ngClass]="{ 'active-link': last }"
										data-testid="breadcrumbNavigate"
										[pTooltip]="item?.label?.length > 25 ? item.label : null">
										{{ item.label }}
									</a>
								}
								@if (!item.url) {
									<span [ngClass]="{ 'active-link': last }" data-testid="breadcrumbNavigate" [pTooltip]="item.label?.length > 25 ? item.label : null">
										{{ item.label }}
									</span>
								}
								@if (!last) {
									<i class="pi pi-chevron-right app-header-breadcrumb-icon"></i>
								}
							</li>
						}
					</ul>
				}
				<div class="app-subscription-badge-container">
					@if (showDemoBadge()) {
						<p-chip label="demo" class="app-subscription-badge-demo" />
					}
					@if (showTestBadge()) {
						<p-chip label="sandbox" class="app-subscription-badge-sandbox" />
					}
					@if (showEnvironmentBadge()) {
						<p-chip [label]="getEnvironmentBadge()" class="app-subscription-badge-environment" />
					}
				</div>
			</div>
		}
	</ng-template>

	<ng-template #end>
		<div class="app-header-actions">
			@if (appContext.showFilter && appContext.userHasValidSubscription() && !appContext.isExternalUser()) {
				<p-floatlabel class="app-header-filter-wrapper" variant="on">
					<p-multiselect
						#viewByMultiselect
						id="viewBy"
						class="app-header-filter-select"
						[options]="appMain.itemGroups"
						[group]="true"
						[(ngModel)]="appMain.selectedItems"
						scrollHeight="250px"
						display="chip"
						filter
						[maxSelectedLabels]="3"
						(onChange)="onViewByFilterChange($event)"
						(onPanelHide)="onViewByFilterPanelHide()"
						data-testid="view-by-filter"
						appendTo="body">
						<ng-template let-dropDown pTemplate="item">
							<div class="flex w-full max-w-100 flex-row items-center justify-between gap-4 text-sm">
								<span class="word-break whitespace-normal">
									{{ dropDown.label == null ? '' : dropDown.label }}
								</span>
								<span class="text-xs">
									{{ dropDown.IsInactive == null ? '' : dropDown.IsInactive ? 'Inactive' : 'Active' }}
								</span>
							</div>
						</ng-template>
						<ng-template let-group #group>
							<div class="flex items-center">
								<i class="{{ group.icon }} mr-1"></i>
								<span>{{ group.label }}</span>
							</div>
						</ng-template>
					</p-multiselect>
					<label for="viewBy">View By</label>
				</p-floatlabel>
			}
			<div class="app-header-user-section" #userProfileMenu>
				<div class="app-header-user-meta">
					@if (getDisplayName()) {
						<span class="app-header-user-name" [pTooltip]="getDisplayName()">
							{{ getDisplayName() }}
						</span>
					}
					@if (getSubscriberName()) {
						<span class="app-header-user-subscriber" [pTooltip]="getSubscriberName()">
							{{ getSubscriberName() }}
						</span>
					}
				</div>
				<!-- User Avatar with Menu -->
				<p-avatar
					#profileMenuTrigger
					icon="pi pi-user"
					shape="circle"
					class="app-header-avatar"
					(click)="onProfileMenuToggle($event)"
					data-testid="userProfileAvatar" />
				<!-- Custom Profile Menu -->
				@if (profileMenuOpen) {
					<div #profileMenuPanel class="app-profile-menu-panel" data-testid="profileMenuPanel">
						<p-menu [model]="profileMenuItems" [popup]="false" (onItemClick)="hideProfileMenu()" />
					</div>
				}
			</div>
		</div>
	</ng-template>
</p-menubar>
